import React from 'react';
import renderHTML from 'react-render-html';
import { EventHeaderDescription } from './content-types';
import { BOOTSTRAP_COLUMN_WIDTH } from '../../../app-constants';

export const EventsRow = ({ wrapperName, automatedTestingId, children }) => (
  <div className={`${wrapperName ? (`${wrapperName} `) : ''}row event-row`} id={automatedTestingId}>
    {children}
  </div>
);

export const EventRowHeader = ({ headingPriority, title, description }) => {
  const CustomTag = `h${headingPriority}`;
  return (<div className="col-12">
    <CustomTag className="text-center">{renderHTML(title)}</CustomTag>
    {description && <EventHeaderDescription description={description} />}
  </div>);
};

export const OffsetBootstrapColumnWrapper = ({ columnOffset, columnsWide, wrapInRow, children }) => {
  const offset = columnOffset || Math.floor((BOOTSTRAP_COLUMN_WIDTH - columnsWide) / 2);
  const subComponent = <div className={`col col-sm-${columnsWide} offset-sm-${offset}`} >{children}</div>;
  return (
    wrapInRow
      ? <div className="row">{subComponent}</div>
      : <React.Fragment>{subComponent}</React.Fragment>
  );
};
